export { default as CarouselWidget } from './Carousel';
